function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke:#397BBF;stroke-width:6;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("polyline", {
  className: "st0",
  points: "12.1,12.4 12.1,46.2 37.9,33.3 60.3,46.2 60.3,12.4 "
});

var _ref4 =
/*#__PURE__*/
React.createElement("polyline", {
  className: "st0",
  points: "118.3,46.2 118.3,12.4 92.5,27.5 70.1,12.4 70.1,46.2 "
});

var _ref5 =
/*#__PURE__*/
React.createElement("polyline", {
  className: "st0",
  points: "171.8,12.4 130.3,12.4 130.3,46.2 171.8,46.2 171.8,33.3 153.8,33.3 "
});

var _ref6 =
/*#__PURE__*/
React.createElement("polyline", {
  className: "st0",
  points: "183.3,46.2 183.3,12.4 222.8,12.4 222.8,27.5 204.8,30.4 222.8,34.5 222.8,46.2 "
});

var SvgWmgrLogo = function SvgWmgrLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 236 57.3",
    style: {
      enableBackground: "new 0 0 236 57.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWmgrLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wmgr_logo.e07669c6.svg";
export { ForwardRef as ReactComponent };